import React from 'react';
import useUpcomingEvents from '../hooks/useUpcomingEvents';
import SEO from '../components/SEO';
import { seoConfig } from '../config/seo';
import { createOrganizationSchema, createEventSchema, createWebSiteSchema, DEFAULT_FAQ_SCHEMA } from '../utils/seoSchemas';
import HeroSection from '../components/home/HeroSection';
import TickerMarquee from '../components/home/TickerMarquee';
import TicketsSection from '../components/home/TicketsSection';
import ExperienceSection from '../components/home/ExperienceSection';
import VIPBookingSection from '../components/home/VIPBookingSection';
import VideosSection from '../components/home/VideosSection';
import SpotifySection from '../components/home/SpotifySection';
import IdeologySection from '../components/home/IdeologySection';
import AppSection from '../components/home/AppSection';


const HomePage = () => {
  const { events, status, retry } = useUpcomingEvents();
  const featuredEvent = events[0];

  // Combine multiple schemas — WebSite + Organization + FAQs + featured Event
  const combinedSchema = {
    "@context": "https://schema.org",
    "@graph": [
      createWebSiteSchema(),
      createOrganizationSchema(),
      DEFAULT_FAQ_SCHEMA,
      ...(featuredEvent ? [createEventSchema(featuredEvent)] : [])
    ]
  };

  return (
    <div data-testid="home-page">
      <SEO
        {...seoConfig.home}
        ogType="website"
        structuredData={combinedSchema}
        hreflang={[
          { lang: 'fr', url: '/' },
          { lang: 'es', url: '/es' },
          { lang: 'x-default', url: '/' },
        ]}
      />
      <HeroSection />
      <TickerMarquee />
      <TicketsSection events={events} status={status} retry={retry} />
      <ExperienceSection />
      <VIPBookingSection />
      <VideosSection />
      <SpotifySection />
      <IdeologySection />
      <AppSection />
      {/* Add padding at bottom for mobile tickets bar */}
      <div className="h-20 lg:h-0" />
    </div>
  );
};

export default HomePage;
